import styled from 'styled-components';

export const StyledWrapper = styled.div`
    width: 100%;
    padding: 0 24px;
`;
